import type { ReactNode } from 'react';

interface SectionHeadProps {
  kicker?: string;
  title: string;
  sub?: string;
  action?: ReactNode;
  className?: string;
}

export function SectionHead({ kicker, title, sub, action, className = '' }: SectionHeadProps) {
  return (
    <div className={`flex items-end justify-between gap-3 ${className}`}>
      <div className="min-w-0">
        {kicker && (
          <div className="font-mono-num text-[10px] uppercase tracking-[0.18em] text-ink-faint dark:text-slate-500 mb-1">
            {kicker}
          </div>
        )}
        <h2 className="text-lg sm:text-xl font-semibold text-ink dark:text-slate-50 truncate">
          {title}
        </h2>
        {sub && (
          <p className="text-xs sm:text-sm text-ink-muted dark:text-slate-400 mt-0.5">{sub}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
